import React, { useState, useEffect } from 'react';
import SingleMAP2 from './SEARCHALERTS/SingleMAP2';
import { useNavigate } from 'react-router-dom';
import Loader from './Skleton/Loader';

export default function ViewAgency() {
  const [inputValue, setInputValue] = useState('');
  const [suggestions, setSuggestions] = useState([]);
  const [selectedOption, setSelectedOption] = useState("");
  const [cityy, setcityy] = useState('')
  const [coordinates, setCoordinates] = useState("");



  const [agency, setagency] = useState([])

  const [dosplayagency, setdosplayagency] = useState(false)


  const [filter, setfilter] = useState([])

  const [filteropen, setfilteropen] = useState(false)


  const [isloading, setisloading] = useState(false)


  const nav = useNavigate()


  async function handleDropdownChange(e) {
    setSelectedOption(e.target.value);
    console.log('Selected Option:', e.target.value);

    setisloading(true)
  
    const res = await fetch('https://alerting-disaster-ndf5g2xba-pratham704.vercel.app/filteragency', {
      method: 'POST',
      body: JSON.stringify({ selectedOption: e.target.value ,cityy}),
      headers: { 'Content-Type': 'application/json' },
    });
  
    const r= await res.json()
    console.log(r)


    if(r ==="noregagencyforfilters"){


           setagency(r)

    }

    else{



setagency(r)


    }


    setisloading(false)

  }
  


  useEffect(() => {
    fetchSuggestions();
  }, [inputValue]);



  useEffect(() => {


    console.log("hi")
    // Check if geolocation is available in the browser
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          const coordinatesString = `${longitude},${latitude}`;
          setCoordinates(coordinatesString);

         
        },
        (error) => {
          console.error("Error getting geolocation:", error);
        }
      );
    } else {
      console.error("Geolocation is not available in this browser.");
    }
  }, []);


  const fetchSuggestions = () => {
    const mapboxAccessToken = 'pk.eyJ1IjoicHJhdGhhbTcwNCIsImEiOiJjbG1xaDJrdzEwNHVpMnFwaXloODIwc2Q0In0.M-0gUqeNHe6A9Z7LeaVFVw'; // Replace with your Mapbox access token

    fetch(
      `https://api.mapbox.com/geocoding/v5/mapbox.places/${inputValue}.json?country=IN&types=place&access_token=${mapboxAccessToken}`
    )
      .then((response) => response.json())
      .then((data) => {
        // Filter the results to get only city names
        const cityNames = data.features
          .filter((feature) => feature.place_type.includes('place'))
          .map((feature) => feature.place_name.split(',')[0]);

        // Update the suggestions state
        setSuggestions(cityNames);
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  };


  async function allagencyinmycity(city) {



    setisloading(true);
    setcityy(city)
    const res = await fetch('https://alerting-disaster-ndf5g2xba-pratham704.vercel.app/allagencyinmycitys', {
      method: 'POST',
      body: JSON.stringify({ city }),
      headers: { 'Content-Type': 'application/json' },
    });
  
    if (res.ok) {
      const ans = await res.json();
      console.log(ans);
  
      if (ans === "notdone") {

        setagency(ans);

setdosplayagency(true)
      }


      else{


        setagency(ans);
        setdosplayagency(true)

      }
    } else {
      console.error("Error fetching achievements");
    }


    setisloading(false)
  }
  






  return (
    <>
      {/* <SingleMAP2 coordinate="74.51905667788769,15.882675787447672" colour="orange" /> */}
      <SingleMAP2 coordinate={coordinates} colour="orange" />


      <div className="mt-4 p-4 border rounded-lg shadow-md" style={{ width: '90%', marginLeft: '5%', marginRight: '5%' }}>
      <input
  type="text"
  placeholder="Enter a city"
  value={inputValue}
  onChange={(e) => setInputValue(e.target.value)}
  className="w-full p-2 border rounded-md shadow-inner focus:shadow-outline"
  style={{ outline: 'none' }} // Add this line to remove the outline
/>


        <ul className="mt-2">
          {suggestions.map((city, index) => (
            <li    onClick={()=>{
       setInputValue(city)
       allagencyinmycity(city)

            }}  key={index} className="p-2 border-b last:border-b-0">
              {city}
            </li>
          ))}
        </ul>
      </div>




      {isloading?<>
      
      

      <br />
      <br />
      
      
      <Loader/>
      <Loader/>
      
      
      
      </>:<>
      
      
      
      
      {dosplayagency?<>



{Array.isArray(agency) && agency.length > 0 ? (

    <>
    <br />
    <br />
<div className="form-group ">
  <select
    id="expertise"
    value={selectedOption}
    onChange={handleDropdownChange}
    required
    className="w-80 px-4 py-2 border rounded-md shadow-md text-gray-700 bg-white hover:shadow-lg focus:ring focus:ring-blue-200 focus:outline-none"
  >
    <option value="">Filter via Expertise</option>
    <option value="Search and Rescue">Search and Rescue</option>
    <option value="Emergency Medical Services">Emergency Medical Services</option>
    <option value="Firefighting">Firefighting</option>
    <option value="Logistics and Supply Chain">Logistics and Supply Chain</option>
    <option value="Emergency Management">Emergency Management</option>
    <option value="others">Others</option>
  </select>
</div>



    
       


<div className="earthquake-info-container">
  {agency.map((achievement) => (
    <div key={achievement._id} className="earthquake-info-box2 cursor-pointer bg-white p-4 rounded-lg shadow-md hover:shadow-lg mb-4 transition duration-300 ease-in-out" onClick={() => { nav(`/viewagency/${achievement.agencyId}`); }}>
      <p className="text-xl font-semibold">{achievement.agencyName}</p>
      <hr className="my-2 border-t border-gray-300" />
      <p className="text-base">{achievement.selectedOption}</p>
      <hr className="my-2 border-t border-gray-300" />
      <p className="text-base">{achievement.city}</p>
      <hr className="my-2 border-t border-gray-300" />
      <div className="overflow-hidden">
        <a href={achievement.websiteLink} target="_blank" rel="noopener noreferrer" className="text-blue-500 hover:underline text-sm block overflow-ellipsis whitespace-nowrap overflow-hidden">
          {achievement.websiteLink}
        </a>
      </div>
    </div>
  ))}
</div>














  </>
) : (
  <>

   {agency ==="noregagencyforfilters"?<>
   

   <div className="earthquake-info-container">
    <div className="earthquake-info-box2 cursor-pointer">
      <p>No agency for {selectedOption} filter in {cityy}</p>
    </div>
    </div>


    <div className="form-group">
<br />
<br />
      <select
        id="expertise"
        value={selectedOption}
        onChange={handleDropdownChange}
        required
      >
        <option value="">Filter via Expertise</option>
        <option value="Search and Rescue">Search and Rescue</option>
        <option value="Emergency Medical Services">
          Emergency Medical Services
        </option>
        <option value="Firefighting">Firefighting</option>
        <option value="Logistics and Supply Chain">
          Logistics and Supply Chain
        </option>
        <option value="Emergency Management">Emergency Management</option>
        <option value="others">Others</option>
      </select>
    </div>




   
   
   </>:<>
   
   <div className="earthquake-info-container">
    <div className="earthquake-info-box2 cursor-pointer">
      <p>NO AGENCY IN UR REGION</p>
    </div>
  </div>
   
   </>}


  
  </>
)}







</>:<>



<div className="earthquake-info-container">
    <div className="earthquake-info-box2 cursor-pointer">
      <p>please search
</p>
    </div>
  </div>




</>}


      
      
      
      
      
      
      
      
      
      
      
      </>}











  





    </>
  );
}
